import { getData } from "./index.svc"

export const login = async (pwd) => {
    const resp = await getData(`login`, 'POST', {
        pwd: btoa(pwd)
    })
    return resp?.[0]?.Type || ''
}